import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import TripTunes from './triptunes';
import BlackJack from './blackjack';
import AirMap from './airmap';
import Flappsy from './flappsy';
import POCB from './pocb';
import TAXIdb from './taxidb';
import Kalshi from './kalshi';
import GeminiXBot from './gemini-x-bot';


function App() {
  const data = {
    imageUrl: process.env.PUBLIC_URL + '/Avatar.jpg', 
    links: [
      { text: 'My CV', url: process.env.PUBLIC_URL + '/ElsonAllmucaCV.pdf' },
      { text: 'My LinkedIn', url: 'https://www.linkedin.com/in/elson-allmuca-630ab7122/' },
      { text: 'My GitHub', url: 'https://github.com/elson99'}
    ],
    projects: [
      {
        title: 'Kalshi Trading System',
        description: 'A full-stack Kalshi trading operation with live portfolio oversight, real-time bot monitoring, and a responsive interface you can control from desktop or mobile.',
        link: 'https://github.com/elson99/kalshi-trading-system',
        rmlink: '/kalshi'
      },
      {
        title: 'X-Bot with Gemini API',
        description: 'An X-Bot that uses the Gemini API to generate tweets based on the user\'s prompt. It uses the Gemini API to generate the tweets and the X API to post them.',
        link: 'https://github.com/elson99/x-bot-with-gemini-api',
        rmlink: '/gemini-x-bot'
      },
      {
        title: 'P.O.C.B.',
        description: 'Paranormal Object Countermeasures Bureau (P.O.C.B.) is a 3D single player horror game, made with Unity and C#. The game is set inside a haunted school and the player has to find a way out while avoiding the monsters. Soon on Steam!',
        link: 'https://github.com/bdaza3/Paranormal-Object-Countermeasures-Bureau',
        rmlink: '/pocb'
      },
      {
        title: 'TripTunes',
        description: 'This fun project lets users Authenticate their Spotify account and create a new playlist with the length of their trip using our APIs.',
        link: 'https://0dcae7f1.triptunes.pages.dev/',
        rmlink: '/triptunes'
      },
      {
        title: 'Taxi Database System',
        description: 'A database system for a taxi company that allows users to manage drivers, customers, and rides. The system is built using Python, Flask, and PostgreSQL.',
        link: 'https://github.com/elson99/taxidb',
        rmlink: '/taxidb'
      },
      {
        title: 'Flappsy Bird',
        description: 'A Flappy Bird copycat built with the intention to learn more about C# and Unity. Found out Unity is a lot of fun!',
        link: 'https://github.com/elson99/flappsy',
        rmlink: '/flappsy'
      },
      {
        title: 'AirMap',
        description: 'This app gets real time air pollution data from around UIC campus and shows it to the user in multiple forms. Front-end is written in JAVA and back-end is written in C/C++.',
        link: 'https://github.com/elson99/AirMap',
        rmlink: '/airmap'
      },
      {
        title: 'BlackJack',
        description: "A simple BlackJack game written in JAVA using JavaFX for the GUI. Beat the dealer and win some virtual money!",
        link: 'https://github.com/elson99/BlackJackJAVA',
        rmlink: '/blackjack'
      }
    ]
  };

  return (
    <Router>
      <div className="App"  style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/background.PNG)`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }}>
        <Routes>
          <Route path="/" element={
            <div className="App-body">
              <div className="left-column">
                <div className="persInfo">
                  <img src={data.imageUrl} alt="Avatar" />
                  <div className="textInfo">
                    <br />
                    <h4>Elson Allmuca</h4> 
                    <h4>Computer Science @UIC</h4>
                    <br />
                    <p>Quantitative Analyst by day,</p>
                    <p>Software Engineer by night.</p>                    
                  </div>
                </div>
                <div className="linkHere">
                  <h2>Check out my CV:
                  <a href={data.links.find(link => link.text === 'My CV').url} target="_blank" rel="noopener noreferrer">Resume</a>
                  </h2>
                  <h2>GitHub: <a href={data.links.find(link => link.text === 'My GitHub').url} target="_blank" rel="noopener noreferrer">github/elson99</a></h2>
                  <h2>LinkedIn: <a href={data.links.find(link => link.text === 'My LinkedIn').url} target="_blank" rel="noopener noreferrer">linkedin/elson-allmuca</a></h2>
                  <h2>Check out my other website<a href="https://elson99.com/" target="_blank" rel="noopener noreferrer">here.</a></h2>
                </div>
                </div>
              <div className="right-column">
                <div className="myProjects">
                  <h2>Recent Projects:</h2>
                  {data.projects.map((project, index) => (
                    <div key={index} className="project">
                      <h3>{project.title}</h3>
                      <p>{project.description}</p>
                      <a href={project.rmlink} className="read-more">Read More</a>
                      <a href={project.link} target="_blank" rel="noopener noreferrer" className="view-project">View Project</a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          } />
          <Route path="/triptunes" element={<TripTunes />} />
          <Route path="/kalshi" element={<Kalshi />} />
          <Route path="/gemini-x-bot" element={<GeminiXBot />} />
          <Route path="/blackjack" element={<BlackJack />} />
          <Route path="/airmap" element={<AirMap />} />
          <Route path="/flappsy" element={<Flappsy/>} />
          <Route path="/pocb" element={<POCB />} />
          <Route path="/taxidb" element={<TAXIdb />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
